export const searchDropdown =  [
	{
	  title: "Appointment ID",
	  value: "appointmentId"
	},
	{
	  title: "Appointment Type",
	  value: "appointmentType"
	},
	{
		title: "Shipment Id",
		value: "shipmentId"
	},
	{
		title: "Carrier",
		value: "carrierName"
	}
]



// WEBPACK FOOTER //
// ./src/pages/appointmentForm/filter/searchDropdown.js